//@flow
import React from 'react';
import modal from '../../Modal/components/StandardModal.react';
import ModalActions from '../../Actions/modal';
import SessionActions from '../../Actions/session';
import ResetEmailSent from '../../SignIn/components/ResetEmailSent.react';
import Constants from '../../constants';

function _showLoginModal() {
  SessionActions.removeLoginError();
  ModalActions.closeModal(Constants.RESET_EMAIL_SENT_MODAL);
  ModalActions.openModal(Constants.LOGIN_MODAL);
}

type Props = {
  resetEmail:string,
};

function ResetEmailSentModal(props:Props) {
  return (
    <ResetEmailSent
      resetEmail={props.resetEmail}
      showSignIn={_showLoginModal}
    />
  );
}

export default modal<Props>(ResetEmailSentModal, {
  name: Constants.RESET_EMAIL_SENT_MODAL,
  className: 'login-modal reset-email-sent',
});
